import * as React from 'react';
import {Component, ReactNode, RefObject} from 'react';
import {CommentListContainerHot, CommentListContainerNew} from '../commentList';
import * as classNames from 'classnames';
import {L} from '../../lang';
import initCommentInputContainer from '../commentInput';

if (process.env.BROWSER) {
  require('./commentWrap.less');
}

interface ICommentWrapProps {
  shouldShowComment: boolean;
}

interface ICommentWrapState {
  nowPanel: CommentPanel;
}

export enum CommentPanel {
  hot = 'hot',
  new = 'new',
  // mine = 'mine', // 二期实现
}

export default class CommentWrap extends Component<ICommentWrapProps, ICommentWrapState> {
  public CommentInput;
  public outDiv: RefObject<any>;
  constructor(p) {
    super(p);
    this.state = {
      nowPanel: CommentPanel.hot,
    };
    this.outDiv = React.createRef();
    this.CommentInput = initCommentInputContainer();
    this.scrollToComment = this.scrollToComment.bind(this);
  }
  public classNamesForPanel(panel: CommentPanel) {
    return panel === this.state.nowPanel ? ['active'] : [];
  }

  public styleForPanel(panel: CommentPanel) {
    return panel === this.state.nowPanel ? {} : {display: 'none'};
  }

  public changePanel(panel: CommentPanel) {
    this.setState({
      nowPanel: panel,
    });
  }
  public render(): ReactNode {
    const {CommentInput} = this;
    if (!this.props.shouldShowComment) {
      return null;
    }
    return (
      <div className="comment-list-v2 comment-show-stat" ref={this.outDiv}>

        <div className="cmt-title">
          <div className={classNames(['cmt-title-item', ...this.classNamesForPanel(CommentPanel.hot)])}
               onClick={(e) => {e.preventDefault(); this.changePanel(CommentPanel.hot); }}>
            {L('comment.hot')}
          </div>
          <div className={classNames(['cmt-title-item', ...this.classNamesForPanel(CommentPanel.new)])}
               onClick={(e) => {e.preventDefault(); this.changePanel(CommentPanel.new); }}>
            {L('comment.new')}
          </div>
          {/*<div className={classNames(['cmt-title-item', ...this.classNamesForPanel(CommentPanel.mine)])}
               onClick={(e) => {e.preventDefault(); this.changePanel(CommentPanel.mine); }}>
            MINE
          </div>*/}
        </div>

        <div className="comment-list2 comment-show-stat">

          <div className="comment-list-hot" style={{...this.styleForPanel(CommentPanel.hot)}}>
            <CommentListContainerHot></CommentListContainerHot>
          </div>

          <div className="comment-list-new" style={{...this.styleForPanel(CommentPanel.new)}}>
            <CommentListContainerNew></CommentListContainerNew>
          </div>
          {/*<div className="comment-list-mine-panel" style={{...this.styleForPanel(CommentPanel.mine)}}>
            <CommentListContainerMine></CommentListContainerMine>
          </div>*/}

        </div>
        <CommentInput></CommentInput>

      </div>
    );
  }

  public scrollToComment() {
    try {
      this.outDiv.current.scrollIntoView();
    } catch (e) {
      console.error('scrollToComment\n', e + '');
    }
  }

  public componentDidMount(): void {
    // // 只有addEventListener才能拿到自定义事件的数据
    document.addEventListener('comment:view', this.scrollToComment);
  }

  public componentWillUnmount(): void {
    document.removeEventListener('comment:view', this.scrollToComment);
  }
}
